
import { computed, defineComponent, Ref, ref, ComputedRef } from 'vue'
import AppHeader from '@/components/Header.vue'
import { List, PullRefresh, ImagePreview } from 'vant'
import refreshPageSetup from '@/compositions/refreshPage'
import { GetServiceHistories } from '@/apis/standby'
import getRoute from '@/compositions/route'
import { ServiceItem } from '@/types/standby'
import uploadFilesSetup from '@/compositions/uploadFiles'
import { ImageInfo } from '@/types/public'

export default defineComponent({
  name: 'Standby-Servicehistories',
  components: {
    AppHeader,
    VanList: List,
    VanPullRefresh: PullRefresh,
  },
  setup() {
    let {
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      generateLoad,
      generateRefresh,
      errorDealFunc,
    } = refreshPageSetup()
    const { params } = getRoute()
    const { getFiles } = uploadFilesSetup()
    const imgs: Ref<ImageInfo[]> = ref([])
    const items: Ref<ServiceItem[]> = ref([])
    const getItems = async (): Promise<void> => {
      const ts: number = _ts
      try {
        let list: ServiceItem[] = await GetServiceHistories({
          sn: (params.value?.sn as string) || '',
        })
        list = list || []
        if (ts !== _ts) return
        if (refreshing.value) {
          items.value = []
          refreshing.value = false
        }
        const imgGuids: string[] = []
        list.forEach((it) => {
          if (it.external?.img?.length) {
            const imgs = it.external.img
            imgGuids.push(...imgs)
          }
        })
        if (imgGuids.length) {
          getFiles([], imgGuids)
            .then((res) => {
              if (ts !== _ts) return
              if (res?.fileObjArr?.length) {
                imgs.value.push(...res.fileObjArr)
              }
            })
            .catch((err: unknown) => {
              if (ts !== _ts) return
              const message: string = (err as { message: string }).message
              console.error(message)
            })
        }
        items.value = _query.page === 1 ? list : items.value.concat(...list)
        loading.value = false
        finished.value = list.length < _query.per_page
      } catch (err: unknown) {
        if (ts !== _ts) return
        errorDealFunc(err as { message: string })
      }
    }
    const onLoad = generateLoad(getItems)
    const onRefresh = generateRefresh(getItems)

    const displayItems: ComputedRef<ServiceItem[]> = computed((): ServiceItem[] => {
      return items.value.map((it) => {
        if (it.external?.img?.length) {
          const imgGuids = it.external.img
          const len = imgGuids.length
          const images: string[] = []
          imgs.value.some((imgObj) => {
            if (imgGuids.includes(imgObj.uid)) {
              images.push(imgObj.url)
            }
            if (len <= images.length) return true
          })
          it.imgs = images
        }
        return it
      })
    })
    return {
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      items,
      onLoad,
      onRefresh,
      getItems,
      imgs,
      displayItems,
    }
  },
  methods: {
    getBigImages(i: number, imgs: string[]): void {
      ImagePreview({
        images: imgs,
        startPosition: i,
      })
    },
  },
})
